'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _get2 = require('babel-runtime/helpers/get');

var _get3 = _interopRequireDefault(_get2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _curry2 = require('lodash/curry');

var _curry3 = _interopRequireDefault(_curry2);

var _class;

var _d = require('d3');

var _d2 = _interopRequireDefault(_d);

var _ramda = require('ramda');

var _background = require('../background/');

var _background2 = _interopRequireDefault(_background);

var _utils = require('../utils/');

var utils = _interopRequireWildcard(_utils);

var _constants = require('../utils/constants');

var _selectors = require('./selectors');

var _selectors2 = _interopRequireDefault(_selectors);

var _accessors = require('./accessors');

var _accessors2 = _interopRequireDefault(_accessors);

var _computors = require('./computors');

var _computors2 = _interopRequireDefault(_computors);

var _eauors = require('./eauors');

var _eauors2 = _interopRequireDefault(_eauors);

var _getAxisOptions = require('../utils/getAxisOptions');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BarChart = (0, _selectors2.default)(_class = (0, _accessors2.default)(_class = (0, _computors2.default)(_class = (0, _eauors2.default)(_class = function (_BackgroundChart) {
  (0, _inherits3.default)(BarChart, _BackgroundChart);

  function BarChart(el) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    var getInitialOptions = arguments[3];
    var getAxisOptions = arguments[4];
    (0, _classCallCheck3.default)(this, BarChart);

    var _this = (0, _possibleConstructorReturn3.default)(this, (BarChart.__proto__ || (0, _getPrototypeOf2.default)(BarChart)).call(this, el, options, data, getInitialOptions));

    _contructor(el, _this.options, data, {
      selectors: _this.constructor.selectors,
      accessors: _this.constructor.accessors,
      computors: _this.constructor.computors,
      eauors: _this.constructor.eauors
    }, _this.base, _this.axis);
    return _this;
  }

  (0, _createClass3.default)(BarChart, [{
    key: 'update',
    value: function update(el) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      var getInitialOptions = arguments[3];
      var getAxisOptions = arguments[4];

      (0, _get3.default)(BarChart.prototype.__proto__ || (0, _getPrototypeOf2.default)(BarChart.prototype), 'update', this).call(this, el, options, data, getInitialOptions);
      _update(el, this.options, data, {
        selectors: this.constructor.selectors,
        accessors: this.constructor.accessors,
        computors: this.constructor.computors,
        eauors: this.constructor.eauors
      }, this.base, this.axis, getAxisOptions);
    }
  }]);
  return BarChart;
}(_background2.default)) || _class) || _class) || _class) || _class;

exports.default = BarChart;


function _contructor(el, options, data, ors, base, axis) {
  //console.info(utils.prefix, '\t\t\t\t', 'BarChart', '_contructor', '>>');

  utils.noElError(el);

  _d2.default.select(el).select(utils.selector(ors.selectors.base)).call(utils.setupElement, 'svg:g', ors.selectors.serie);

  _update(el, options, data, ors, base, axis);

  //console.info(utils.prefix, '\t\t\t\t', 'BarChart', '_contructor', '<<');
}

function _update(el, options, data, ors, base, axis, getAxisOptions) {
  //console.info(utils.prefix, '\t\t\t\t', 'BarChart', '_update', '>>');
  if (process.env.NODE_ENV !== 'production') {
    console.time(utils.prefix + ' BarChart#_update');
  }

  utils.noElError(el);
  if (utils.noDataError(ors.accessors.data(data), '\t\t\t\t', 'BarChart')) {
    _d2.default.select(el).selectAll(utils.selector(ors.selectors.bar)).remove();
    return;
  }

  var scales = {
    xScale: ors.accessors.xScale(base, axis),
    yScale: ors.accessors.yScale(base, axis)
  };

  var pivots = { xPivot: base.xPivot, yPivot: base.yPivot };

  _d2.default.select(el).selectAll(utils.selector(ors.selectors.serie)).data(data);

  var barJoin = _d2.default.select(el).select(utils.selector(ors.selectors.serie)).selectAll(utils.selector(ors.selectors.bar)).data(ors.computors.data(data));
  barJoin.enter().call(ors.eauors.barEnter, options.serie, ors.selectors.bar);
  barJoin.call(ors.eauors.barUpdate, options.serie, ors.accessors);
  barJoin.exit().remove();

  var rectJoin = barJoin.selectAll(utils.selector(ors.selectors.rect)).data(function (datum) {
    return [datum];
  });
  rectJoin.enter().call(ors.eauors.rectEnter, options.serie, ors.selectors, ors.accessors, base.hideTooltip);
  rectJoin.call(ors.eauors.rectUpdate, options, ors.accessors, scales, pivots, base.showTooltip);
  rectJoin.exit().remove();

  if (options.serie.annotation.display !== _constants.NEVER) {
    var annotationJoin = barJoin.selectAll(utils.selector(ors.selectors.annotation)).data((0, _curry3.default)(ors.computors.annotationData)(options.serie.annotation, scales.xScale));
    annotationJoin.enter().call(ors.eauors.annotationEnter, options.serie, ors.selectors.annotation);
    annotationJoin.call(ors.eauors.annotationUpdate, options, ors.accessors, scales, pivots);
    annotationJoin.exit().remove();
  }

  var xAxisLabelJoin = _d2.default.select(el).select(utils.selector(ors.selectors.xAxis)).selectAll('text').data(ors.computors.data(data));
  xAxisLabelJoin.call(ors.eauors.xAxisLabelUpdate, options.serie, ors.accessors);

  if ((0, _ramda.is)(Function, getAxisOptions)) {
    var yAxisoptions = (0, _getAxisOptions.getLinearAxisOptions)(axis.yAxis, options.axis.y);
    getAxisOptions({
      computedMinY: yAxisoptions.min,
      computedMaxY: yAxisoptions.max,
      computedStepY: yAxisoptions.step,
      computedPivotY: yAxisoptions.pivot
    });
  }
  //console.info(utils.prefix, '\t\t\t\t', 'BarChart', '_update', '<<');
  if (process.env.NODE_ENV !== 'production') {
    console.timeEnd(utils.prefix + ' BarChart#_update');
  }
}